import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image"

import { coloredResult } from "../lib/fuzzytext"

import * as styles from "../styles/search-result.module.css"

const SearchResult = ({ query, result, resetHandler }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 500)
    return () => clearTimeout(timer)
  }, [query])

  return (
    <div className={`${styles.fadeUp} ${styles.result}`}>
      <p className={styles.message}>
        {query} の検索結果: {!loading && `${result.length}件`}
      </p>
      {result.length > 0 ? (
        // conditional rendering based on loading state
        loading ? (
          <div className={styles.loading}>
            <img src="/loader.svg" alt="Loading" width={32} height={32} />
          </div>
        ) : (
          <ul className={`p-postList -type-list ${styles.hits}`}>
            {result.map(post => (
              <li key={post.parent.name}>
                <article>
                  <Link to={`/${post.parent.name}/`} className="p-postLink">
                    <div className="p-postThumb">
                      <figure>
                        {post.frontmatter.image?.childImageSharp
                          ?.gatsbyImageData ? (
                          <GatsbyImage
                            image={getImage(post.frontmatter.image)}
                            alt={post.frontmatter.title}
                            className="p-postImg"
                          />
                        ) : (
                          <StaticImage
                            src="../images/site-header.jpg"
                            alt="No Image"
                            className="p-postImg"
                            objectFit="cover"
                            width={80}
                            height={80}
                          />
                        )}
                      </figure>
                    </div>
                    <div className="p-postBody">
                      <h2
                        className={styles.result_heading}
                        dangerouslySetInnerHTML={{
                          __html: coloredResult(post.frontmatter.title, query),
                        }}
                      />
                      <p
                        className={styles.result_excerpt}
                        dangerouslySetInnerHTML={{
                          __html: coloredResult(post.excerpt, query),
                        }}
                      />
                    </div>
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        )
      ) : (
        <p className={styles.hits}>
          検索結果はありません{" "}
          <button type="button" onClick={resetHandler}>
            リセット
          </button>
        </p>
      )}
    </div>
  )
}

export default SearchResult
